import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IGroupManualEntryModel } from "../../services/manual-entry-data-service/Models";
import GroupManualEntryDataService from "../../services/manual-entry-data-service/ManualEntryDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseGetGroupManualEntryValuesParameters = {
    groupID: number,
    date: Date;
} & BaseUseQueryParameters<IGroupManualEntryModel>;

export function useGetGroupManualEntryValues({
    groupID,
    date,
    enabled,
    onError,
    onSuccess
}: UseGetGroupManualEntryValuesParameters) {
    return useQuery<IGroupManualEntryModel | undefined, RestError>(
        keys.groupManualEntryValues(groupID, date),
        ({ signal }) => {
            return GroupManualEntryDataService.getGroupManualEntryData(groupID, date, signal);
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            staleTime: 0,
            refetchOnMount: "always",
            //refetchOnWindowFocus: false
        }
    );
}